import React, { useEffect, useState } from "react";

/**
 * Phase 12.3 — Surgical AgeGate. Replaces the 3-dropdown friction wall with
 * a single "I am 21 or older" button. A "Not yet 21" exit link is provided
 * for under-age visitors. Full date-of-birth verification is deferred to
 * checkout / account creation per directive.
 */
const KEY = "latm_age_verified_v1";

export default function AgeGate() {
  const [verified, setVerified] = useState(() => typeof window !== "undefined" && localStorage.getItem(KEY) === "true");

  useEffect(() => {
    if (verified) document.body.classList.remove("agegate-locked");
    else document.body.classList.add("agegate-locked");
    return () => document.body.classList.remove("agegate-locked");
  }, [verified]);

  if (verified) return null;

  const confirm = () => {
    try { localStorage.setItem(KEY, "true"); } catch (_) {}  // eslint-disable-line no-unused-vars
    setVerified(true);
  };

  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md p-4">
      <div className="glass-panel max-w-md w-full p-8 sm:p-10 text-center fade-up">
        <div className="eyebrow mb-3">Age verification</div>
        <h2 className="font-anton text-3xl sm:text-4xl uppercase mb-2">You must be 21 or older to enter this site</h2>
        <p className="text-lifted-dim text-sm mb-6">By continuing you confirm you are at least 21 years of age. Full date-of-birth verification will be required at checkout.</p>
        <button
          type="button"
          data-testid="age-gate-accept"
          onClick={confirm}
          className="btn-lifted w-full"
        >
          I am 21 or older — enter site
        </button>
        <a
          href="https://www.google.com"
          data-testid="age-gate-decline"
          className="block mt-4 text-xs text-lifted-mute hover:text-lifted-text underline-offset-4 hover:underline"
        >
          Not yet 21 · take me elsewhere
        </a>
        <p className="text-[0.65rem] text-lifted-mute mt-5">By entering this site you agree to the Terms of Use and Privacy Policy.</p>
      </div>
    </div>
  );
}
